// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__1ml8_","row":"style_row__1vcdB","title":"style_title__1cFJy","outlined":"style_outlined__2e8M1"};